// Lib
import { ComponentProps } from 'lib/component-props';
import { PlaceholderWrapper } from 'components/helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { useSitecorePage } from 'lib/hooks/sitecore/useSitecorePage';

export const Default = (props: ComponentProps): JSX.Element => {
  const { RenderingIdentifier } = props?.params || {};

  const page = useSitecorePage();

  return (
    <div
      data-component="authorable/shared/site-structure/main-layout/mainlayout"
      id={RenderingIdentifier}
    >
      <PlaceholderWrapper
        helpTextHideIf={true}
        name="custom-headless-breadcrumb"
        rendering={props.rendering}
      />
      <div
        id="main-layout-content"
        className={page?.fields?.constrainedPageWidth?.value ? 'mainLayoutConstrained' : ''}
      >
        <PlaceholderWrapper name="custom-headless-top-content" rendering={props.rendering} />

        <PlaceholderWrapper name="custom-headless-main-content" rendering={props.rendering} />

        <PlaceholderWrapper name="custom-headless-bottom-content" rendering={props.rendering} />
      </div>
    </div>
  );
};
